(function () {
  angular.module("akitabox.ui.dialogs.export", [
    "ngMaterial",
    "akitabox.core.services.file",
    "akitabox.core.services.flag",
    "akitabox.core.services.http",
  ]);
})();
